import React, { useState } from "react";
import { Layout as AntLayout, Drawer } from "antd";
import Header from "./Header";
import Navigation from "./Navigation";
import Footer from "./Footer";

const { Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };

  return (
    <AntLayout style={{ minHeight: "100vh", backgroundColor: "#FAFAFA" }}>
      {/* Desktop Navigation */}
      <div className="desktop-nav">
        <Navigation />
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={null}
        placement="left"
        closable={true}
        onClose={onClose}
        open={drawerVisible}
        width={300}
        bodyStyle={{ padding: 0 }}
        className="mobile-drawer"
      >
        <Navigation onItemClick={onClose} />
      </Drawer>

      <AntLayout style={{ backgroundColor: "#FAFAFA", position: "relative" }}>
        <Header onMenuClick={showDrawer} />
        <Content
          style={{
            backgroundColor: "#FAFAFA",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            marginLeft: "300px",
            position: "relative",
            minHeight: "calc(100vh - 80px)",
            paddingBottom: "84px",
          }}
        >
          <div style={{ flex: 1 }}>{children}</div>
        </Content>
        <Footer />
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
